// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ICreateCardResponseModel } from './iCreateCardResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CardV1CardV1CreateCardDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': Array<ICreateCardResponseModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CardV1CardV1CreateCardDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<ICreateCardResponseModel>"
        },
    ];

    static getAttributeTypeMap() {
        return CardV1CardV1CreateCardDefaultResponse.attributeTypeMap;
    }
}
